import { injectCpmsBoUserApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-user.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoUserApi = injectCpmsBoUserApi(baseApi);

export const {
  useCpmsBoGetUsersPaginatedQuery,
  useCpmsBoGetUserQuery,
  useCpmsBoCreateUserMutation,
  useCpmsBoUpdateUserMutation,
} = cpmsBoUserApi;
